<template>
  <header>
    <router-link to="/">
      <img src="@/assets/images/logo.png" height="40" loading="lazy" alt="Logo Customily" />
      <p><strong>Welcome</strong> Agustin</p>
    </router-link>
  </header>
</template>

<style scoped lang="scss">
  header {
    background: linear-gradient(145deg, rgba(var(--color_primary),1) 0%, rgba(var(--color_secondary),1) 100%);
    padding: em(10) em(20);
    margin-bottom: em(50);
  }
  a {
    display: flex;
    color: white;
    align-items: center;
  }
  img {
    margin-right: em(10);
  }
</style>
